/**
 * MapController Component — Handles map interactions (clean markers)
 */
import React, { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

export function MapController({ selectedRestaurant }) {
  const map = useMap();

  useEffect(() => {
    if (selectedRestaurant && selectedRestaurant.coordinates) {
      map.flyTo(selectedRestaurant.coordinates, 16, {
        duration: 1.5,
        easeLinearity: 0.25
      });
    }
  }, [selectedRestaurant, map]);

  return null;
}

/**
 * Create custom restaurant marker icon — Premium Minimalist Pins
 */
export function createRestaurantIcon(restaurant) {
  // Premium Palette
  let bgColor = '#171717'; // Neutral 900 (Default)
  let ringColor = 'rgba(23, 23, 23, 0.2)';
  let icon = '';
  let size = 32;

  // Badge Logic - Sophisticated Colors
  if (restaurant.badges?.includes('michelin')) {
    bgColor = '#D4A853'; // Michelin Gold
    ringColor = 'rgba(212, 168, 83, 0.3)';
    icon = '⭐';
  } else if (restaurant.badges?.includes('shell_chuan_chim')) {
    bgColor = '#059669'; // Emerald 600
    ringColor = 'rgba(5, 150, 105, 0.3)';
    icon = '🐚';
  } else if (restaurant.badges?.includes('perp_pitsadarn')) {
    bgColor = '#2563EB'; // Royal Blue
    ringColor = 'rgba(37, 99, 235, 0.3)';
    icon = '😋';
  } else if (restaurant.dietary?.includes('vegan')) {
    bgColor = '#10B981'; // Green
    icon = '🌱';
  }

  const html = `
    <div class="relative group" style="width: ${size}px; height: ${size}px;">
      <!-- Pulse Effect (CSS Animation) -->
      <div style="
        position: absolute;
        inset: -4px;
        border-radius: 50%;
        background: ${ringColor};
        opacity: 0;
        transform: scale(0.8);
        animation: pulse-ring 3s cubic-bezier(0.2, 0.8, 0.2, 1) infinite;
      "></div>
      
      <!-- Pin Body -->
      <div style="
        position: relative;
        width: 100%;
        height: 100%;
        background: ${bgColor};
        border: 2px solid white;
        border-radius: 50%;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15), 0 2px 4px rgba(0,0,0,0.1);
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 14px;
        transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
      " class="hover:scale-110">
        ${icon || '<div style="width: 6px; height: 6px; background: white; border-radius: 50%;"></div>'}
      </div>
      
      <!-- Anchor Point (Visual) -->
      <div style="
        position: absolute;
        bottom: -6px;
        left: 50%;
        transform: translateX(-50%);
        width: 0; 
        height: 0; 
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 6px solid ${bgColor};
        filter: drop-shadow(0 2px 1px rgba(0,0,0,0.1));
      "></div>
    </div>
  `;

  return L.divIcon({
    className: 'custom-marker',
    html: html,
    iconSize: [size, size],
    iconAnchor: [size / 2, size + 4], // Anchor at bottom tip
    popupAnchor: [0, -size - 8]
  });
}

export default MapController;
